
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post80() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Oi pessoal! Qual creme vcs usam para a pele? Porque diabetes ressecada bastante a pele</title>
        <meta 
          name="description" 
          content="Oi pessoal! Qual creme vcs usam para a pele? Porque diabetes ressecada bastante a pele"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Luíza Castro &#183; 13/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Oi pessoal! Qual creme vcs usam para a pele? Porque diabetes ressecada bastante a pele
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/80')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  5 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi Luíza!<br/><br/>A pele ressecada é bem comum em pessoas com diabetes, e cuidar dela é muito importante para evitar complicações. Muitos pacientes têm bons resultados com hidratantes que contêm ureia ou ceramidas, pois ajudam a manter a pele hidratada por mais tempo.<br/><br/>Uma dica é aplicar o creme logo após o banho, quando a pele ainda está levemente umedecida, isso ajuda a reter a umidade. Outra coisa importante é evitar banhos muito quentes e prolongados, pois eles podem ressecar ainda mais a pele.<br/><br/>Sempre vale a pena conversar com seu médico ou enfermeiro para verificar qual creme seria o mais adequado para você. E claro, manter a glicemia bem controlada também ajuda muito na saúde da pele.<br/><br/>Espero ter ajudado! Qualquer coisa, estamos aqui.<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 13/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/80')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    J. Sandel &#183; 06/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/24-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Dúvida Pré-diabetes  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa noite pessoal. Tenho uma dúvida:<br/><br/>Pré-diabético toma medicamentos pra diabetes ou só faz dieta?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/24')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Rita Anton &#183; 06/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/22-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Diabetes dicas  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Gente, boa dia!<br/><br/>Eu fui diagnosticada com diabetes fazem uma semaninhas e comecei uma reeducação alimentar (fui na nutri). Mas não estou acompanhando a glicemia, não tenho o aparelho ainda. Vocês acham que precisa comprar? Ou dá pra fazer na farmácia de vez em quando?<br/><br/>Obrigado!
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/22')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Danna Rosa &#183; 16/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/108-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom dia pessoal. Tenho diabetes, e quero tirar uma dúvida. <br/>Esse negócio de tomar uma colherzinha de vinagre antes do almoço, é verdade ou ilusão?<br/>Percebo que no pós fica baixa a glicemia, mas fico em dúvida se em algum momento que não estou controlando, da pico.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/108')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            5 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/7-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Colesterol bom e colesterol ruim  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Uma das primeiras coisas que descobri depois do diagnóstico de colesterol alto foi que existem dois tipos de colesterol: o colesterol ruim (LDL) e o colesterol do bem (HDL). O colesterol total é a soma desses dois, e colesterol alto é ruim porque quando ele está alto, a maior parte dele é composta do colesterol ruim (LDL). <br/><br/>Importante: Pessoas com colesterol alto têm cerca de o dobro do risco de desenvolverem uma doença cardíaca em comparação com pessoas com níveis de colesterol normais.<br/><br/>Assim, para melhorar o colesterol, o que precisamos fazer é tentar REDUZIR nosso colesterol ruim (LDL) enquanto AUMENTAMOS nosso colesterol bom (HDL). <br/><br/>A primeira causa de termos alto colesterol ruim (LDL) é comer comidas que têm gorduras ruins para nós (gorduras trans e gorduras saturadas). O colesterol bom (HDL) ajuda a combater e reduzir o colesterol ruim (LDL), e quantidade muito baixa dele é uma causa de doença cardíaca.<br/><br/>Os três fatores SOB NOSSO controle que influenciam nosso colesterol (aumentam o bom, reduzem o ruim) são:<br/><br/>1) Nosso peso: Obesidade pode aumentar nosso colesterol ruim (LDL) até 50%, ao mesmo tempo que pode reduzir nosso colesterol bom (HDL) em 20%.<br/><br/>2) O que nós comemos: Tem muita coisa para falar aqui, mas o importante é comer saudável: frutas, verduras, fibras, peixes. Evitar comida processada, frituras, carne vermelha.<br/><br/>3) Exercício físico: Exercício é o último fator porque ele influencia os outros dois: pessoas que se exercitam tendem a comer melhor e pesar menos. Exercício também é chave para fortalecer o músculo do coração.<br/><br/>Aprender sobre esses pontos me ajudou muito no início da minha melhora de saúde, e espero que possa servir para vocês também.<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/7')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        Nenhum comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marília Dornelles &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/87-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom dia pessoal. Estou com diabetes gestacional. Como posso abaixar a diabetes através da alimentação?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/87')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
